import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchAllFraksi } from "redux/features/fraksi";
import { message } from "antd";

export const useFraksi = () => {
  const [fraksi, setFraksi] = useState([]);
  const dispatch = useDispatch();

  const getFraksi = async () => {
    try {
      const res = await dispatch(fetchAllFraksi()).unwrap();
      setFraksi(
        res.data.map((item) => {
          return {
            label: item.name,
            value: item.id,
          };
        })
      );
    } catch (error) {
      message.error(error?.message || "Failed to fetch data");
    }
  };

  useEffect(() => {
    getFraksi();
  }, []); // -> deps = [] ini buat jalan sekali saat pertama render

  return { fraksi };
};
